import 'css-chunksrc/feature/provision/OrgSelect.module.scss';export default {
  "searchFieldWrapper": "OrgSelect_searchFieldWrapper",
  "list": "OrgSelect_list"
};